import { Box, Typography, Avatar, IconButton, Grid, CircularProgress } from "@mui/material";
import { CallEnd, Person } from "@mui/icons-material";
import { colors } from "../../../ui/colors";
import { useOptionalInternalWebRTC } from "../../../internal-contacts/_context/InternalWebRTCContext";
import { useOptionalInternalTwilioCall } from "../../../internal-twilio-call/context/InternalTwilioCallContext";

export const InternalOutgoingCall = () => {
  const webrtc = useOptionalInternalWebRTC();
  const twilio = useOptionalInternalTwilioCall();

  const isTwilio = twilio?.internalCallView === "outgoing-ringing";
  const peerDisplayName = isTwilio
    ? twilio.peerDisplayName
    : webrtc?.peerDisplayName ?? "Internal contact";
  const peerSubtitle = isTwilio ? null : webrtc?.peerSubtitle ?? null;
  const onCancel = () => {
    if (isTwilio) {
      twilio.hangupCall();
      return;
    }
    void webrtc?.cancelOutgoing();
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ height: 560, width: "100%" }}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          width: "100%",
          maxWidth: 320,
          height: "100%",
          py: 3,
          marginTop: { xs: -6 },
          marginBottom: { xs: 10 },
        }}
      >
        <Box textAlign="center">
          <Avatar
            sx={{
              width: 96,
              height: 96,
              backgroundColor: colors.orange.base,
              mx: "auto",
              mb: 3,
              marginTop: { xs: 5 },
            }}
          >
            <Person sx={{ fontSize: 56 }} />
          </Avatar>

          <Typography
            variant="overline"
            sx={{ color: "text.secondary", letterSpacing: 1.2, fontSize: "0.9rem" }}
          >
            Internal call
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 500, mt: 1.5 }}>
            {peerDisplayName}
          </Typography>

          {peerSubtitle && (
            <Typography
              variant="body1"
              sx={{ mt: 1, color: colors.orange.base, fontWeight: 600 }}
            >
              {peerSubtitle}
            </Typography>
          )}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1.5,
              mt: 2,
            }}
          >
            <CircularProgress size={18} />
            <Typography variant="body1" color="text.secondary">
              Calling...
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={0} alignItems="center" justifyContent="center">
          <Grid item display="flex" justifyContent="center">
            <IconButton
              onClick={onCancel}
              sx={{
                width: 72,
                height: 72,
                bgcolor: "#E53935",
                color: "white",
                "&:hover": { bgcolor: "#D32F2F" },
              }}
            >
              <CallEnd sx={{ fontSize: 32 }} />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
